export default __webpack_public_path__ + "static/media/0105.4ce91d31.jpg";